import { render } from "./OurValuesItem.vue?vue&type=template&id=2b2d5c1d"
import script from "./OurValuesItem.vue?vue&type=script&lang=js"
export * from "./OurValuesItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__